import { render, staticRenderFns } from "./modify-company.vue?vue&type=template&id=4a8fbbd8&scoped=true"
import script from "./modify-company.vue?vue&type=script&lang=ts"
export * from "./modify-company.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fbbd8",
  null
  
)

export default component.exports